import { Component, OnInit } from '@angular/core';
import { AuthorizationService } from '../../../shared/services/authorization.service';
@Component({
    selector: 'app-external-login',
    templateUrl: './external-login.component.html',
    standalone: false,
})
export class ExternalLoginComponent implements OnInit {
    constructor(private authorizationService: AuthorizationService) {}
    ngOnInit(): void {
        this.authorizationService.loginEntraId();
    }
}